/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Tmsa_DetailInputs */



/**
* | output |
* | --- |
* | "Support and independent review against OCIMF's Tanker Management and Self-Assessment (TMSA) programme. We help operators benchmark their management system ac..." |
*
* @param {Service_Tmsa_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_tmsa_detail = /** @type {((inputs?: Service_Tmsa_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Tmsa_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("对照 OCIMF 油轮管理与自评估（TMSA）项目提供支持和独立审查。我们帮助运营方在各 TMSA 要素上对标其管理体系，核实每个阶段的证据，并找出需要重点改进的地方。")
	return /** @type {LocalizedString} */ ("Support and independent review against OCIMF's Tanker Management and Self-Assessment (TMSA) programme. We help operators benchmark their management system across the TMSA elements, verify the evidence behind each stage, and identify where to focus improvement.")
});